import { BaseFetch } from "../main-model"
export default class ParentModel extends BaseFetch {
    getParentBy = (data) =>
    this.authFetch({
      url: "parent/getParentBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getParentCheckId = (data) =>
    this.authFetch({
      url: "parent/getParentCheckId",
      method: "POST",
      body: JSON.stringify(data),
    })
    getParentByid = (data) =>
    this.authFetch({
      url: "parent/getParentByid",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateParentById = (data) =>
    this.authFetch({
      url: "parent/updateParentById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertParent = (data) =>
    this.authFetch({
      url: "parent/insertParent",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteParentById = (data) =>
    this.authFetch({
      url: "parent/deleteParentById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
